import React from "react";
import ReactDOM from "react-dom/client";
import Home from "./Conponents/Home";
import Restaurant from "./Conponents/Restaurant";
import {BrowserRouter,Routes,Route} from "react-router"
import RestaurantMenu from "./Conponents/RestaurantMenu";
import RestHeader from "./Conponents/RestHeader";
import SecondaryHome from "./Conponents/SecondaryHome";


function App(){

    return(
        <>
       <BrowserRouter>
       <Routes>
        
        <Route path="/" element={<Home></Home>}> </Route>
        <Route element={<SecondaryHome></SecondaryHome>}>
        <Route path="/restaurant" element={<Restaurant></Restaurant>}></Route>
        <Route path="/city/delhi/:id" element={<RestaurantMenu></RestaurantMenu>}></Route>
        </Route>
       </Routes>
       </BrowserRouter>
       
        </>
        
    )

}

ReactDOM.createRoot(document.getElementById('root')).render(<App></App>)

